import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  violations: null,
  error: false,
  updateSuccess: false,
  user: {
    username: '',
    email: '',
    password: ''
  }
};

const UserSlice = createSlice({
  name: "User",
  initialState,
  reducers: {
    userGetSuccess(state, action) {
      state.user = action.payload
    },
    userGetError(state) {
        state.error = true
    },
    userUpdateSuccess(state, action) {
      state.user = action.payload;
      state.updateSuccess = true
    },
    userUpdateError(state, action) {
      state.violations = action.payload;
      state.error = true;
    },
    userUpdateReset(state) {
      state.violations = null;
      state.error = false;
      state.updateSuccess = false
    },
  },
});

export const {
  userGetSuccess,
  userGetError,
  userUpdateSuccess,
  userUpdateError,
  userUpdateReset,
} = UserSlice.actions

export default UserSlice.reducer;
